<template>
  <div id="app">
    <el-dialog :visible.sync="isLogout" width="25%">
      <span>{{ $t('title.logout') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutFalse()">{{ $t('title.Cancel') }}</el-button>
        <el-button type="primary" @click="logoutTrue()">{{ $t('title.Sure') }}</el-button>
      </span>
    </el-dialog>
    <el-aside 
      style="width:280px;height: 100%;overflow:visible;"
      :style="{background: themesStyle.menuBackground}"
    >
      <div class="user_info">
        <h2>{{roles.name}}</h2>
        <i 
          class="el-icon-switch-button" 
          type="primary" 
          @click="isLogout = true"
          style="color:white;font-size:25px"
        />
      </div>
       
      <navMenu>
      </navMenu>
      
    </el-aside>
   <el-main class="right_body" >
      <p class="system-name">{{systemName}}</p>
      <div class="tab-select-wrap" style="display: inline-block;text-align:center;marginLeft:30px">
          <el-dropdown trigger="click" >
              <span class="el-dropdown-link">
          {{language}}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="languageSwitching('zh')">中文</el-dropdown-item>
              <el-dropdown-item @click.native="languageSwitching('en')">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      <navMain></navMain>
      <div class="table_body">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </el-main>
  </div>
</template>


<script>
import navMenu from "@/components/navMenu/navMenu";
import navHeader from "@/components/header/header";
import navMain from "@/components/navMain/navMain";
import { Themes } from '@/mixin/themes'

import { mapState } from 'vuex'
export default {
  name: "app",
  components: {
    navMenu,
    navHeader,
    navMain
  },
  mixins: [Themes],
  data() {
    return {
      isLogout: false,
      name: '',
      language: '',
    };
  },
  created() {
    this.language_is()
    let lang = localStorage.getItem('lang');
    this.languageSwitching(lang || 'en')
      // this.name = JSON.parse(this.roles).name
  },
  computed: {
    ...mapState({
      roles: state => state.app.roles,
  }),
  languageChange() {
        return this.$i18n.locale;
      }
  },
    watch: {
      languageChange(e) {
        this.language_is()
      }
    },
  methods: {
    logoutFalse() {
      this.isLogout = false;
    },
    logoutTrue() {
      this.$store.dispatch("app/LogOut").then(() => {
        this.isLogout = false;
        location.reload();
      });
    },
    languageSwitching(e) {
        this.$store.dispatch('app/setLanguage', e)
        // location.reload();
      },
    language_is() {
        if (this.$i18n.locale === 'zh') {
          this.language = 'Zh'
        }else {
          this.language = 'En'
        }
      },
  },
  
};
</script>

<style scoped lang="scss">
#app {
  height: 100%;
  display: flex;
}
.login_out {
  margin-left: 20px;
}
.user_info{
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h2 {
    color: white;
    margin-bottom: 0;
  }
}

.changeBtn{
   padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 30px;
}
.right_body {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding-top: 30px;
  .system-name {
    position: fixed;
    right: 80px;
    top: 26px;
    font-size: 16px;
    font-weight: 400;
    font-weight: bold;
  }
  .tab-select-wrap {
    position: fixed;
    right: 20px;
    top: 20px;
    top: 20px;
    width: 34px;
    height: 34px;
    background:#409EFF;
    border-radius:5px;
    line-height: 26px;
    z-index: 888;
    .el-dropdown {
      width: 100%;
      height: 100%;
    }
  }
   .el-dropdown-link {
     z-index: 999;
    cursor: pointer;
    color: #FFF;
    user-select: none;
    font-size: 18px;
    font-weight: bold;
    line-height: 34px;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .table_body {
    flex: 1;
    overflow: auto;

  }
  // .table_body::-webkit-scrollbar { 
  //   display: none; 
  // }
  & /deep/ .el-tabs__header {
    margin: 0;
    margin-top: 30px;
  }
}



</style>
